import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import WryvenLoader from '../components/Loaders/WryvenLoader'

const LoadingSpinner = () => (
  <WryvenLoader />
);

const ProtectedRoute = ({ children, requireAuth = true, redirectTo = "/" }) => {
  const { isAuthenticated, isLoading, sessionChecked } = useAuth();
  const location = useLocation();

  if (isLoading || !sessionChecked) return <LoadingSpinner />;

  if (requireAuth) {
    if (!isAuthenticated) {
      return <Navigate to={redirectTo} state={{ from: location }} replace />;
    }
    return children;
  }

  // This one line replaces the whole array check
  if (isAuthenticated && (location.pathname.toLowerCase() === '/signup' || location.pathname === '/')) {
      return <Navigate to="/explore" replace />;
  }

  return children;
};

export const PublicRoute = ({ children }) => (
  <ProtectedRoute requireAuth={false}>{children}</ProtectedRoute>
);

export const PrivateRoute = ({ children, redirectTo = "/" }) => (
  <ProtectedRoute requireAuth={true} redirectTo={redirectTo}>{children}</ProtectedRoute>
);

export default ProtectedRoute;